import { Components, Theme } from '@mui/material/styles';

export const checkbox = (theme: Theme): Components => {
  const additionalGrey = theme.palette.grey.additionalGrey;
  const mainColor = theme.palette.primary.main;
  const secondTextColor = theme.palette.text.secondary;

  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: additionalGrey,
          borderRadius: 3,
          transition: 'background-color 0.3s, border-color 0.3s',
          padding: 0,
          marginLeft: 0,

          '& . MuiSvgIcon-root': {
            borderRadius: 3,
          },

          '&. Mui-checked': {
            color: mainColor,
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'flex-start',
          gap: 5,
          cursor: 'pointer',
          marginLeft: 0,
          marginRight: 0,
          '&. Mui-disabled': {
            cursor: 'not-allowed',
          },
          [theme.breakpoints.down('sm')]: {
            gap: 3,
          },
        },
        label: {
          fontFamily: theme.typography.fontFamily,
          paddingTop: 4,
          width: '100%',
          fontSize: 13,
          color: secondTextColor,
          cursor: 'pointer',
          '&. Mui-disabled': {
            cursor: 'not-allowed',
            color: secondTextColor,
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: 10,
            paddingLeft: 3,
          },
        },
      },
    },
  } as Components;
};
